module.exports = __webpack_public_path__ + "img/person-2.4b2330bb.png";